import React, { useState } from "react"
import { Button } from "../../../ui/button"
import { useToast } from "../../../hooks/use-toast"

const ContactForm = () => {
  const { toast } = useToast()
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  })
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = e => {
    e.preventDefault()
    setIsSubmitting(true)

    // Simulate form submission
    setTimeout(() => {
      toast({
        title: "Message sent",
        description: "We'll get back to you as soon as possible."
      })
      setFormData({
        name: "",
        email: "",
        message: ""
      })
      setIsSubmitting(false)
    }, 1500)
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div>
        <label
          htmlFor="name"
          className="block text-sm font-medium text-[#3D2A60] mb-1.5"
        >
          Your Name
        </label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          className="w-full px-4 py-3 border border-solid border-[#F4F0FA] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#E563A4] transition-all duration-200 bg-white touch-target"
          placeholder="John Doe"
        />
      </div>

      <div>
        <label
          htmlFor="email"
          className="block text-sm font-medium text-[#3D2A60] mb-1.5"
        >
          Email Address
        </label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
          className="w-full px-4 py-3 border border-solid border-[#F4F0FA] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#E563A4] transition-all duration-200 bg-white touch-target"
          placeholder="john@example.com"
        />
      </div>

      <div>
        <label
          htmlFor="message"
          className="block text-sm font-medium text-[#3D2A60] mb-1.5"
        >
          Your Message
        </label>
        <textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
          rows={4}
          className="w-full px-4 py-3 border border-solid border-[#F4F0FA] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#E563A4] transition-all duration-200 bg-white touch-target resize-none"
          placeholder="How can we help you?"
        />
      </div>

      <Button
        type="submit"
        disabled={isSubmitting}
        className="w-full bg-[#E563A4] hover:bg-[#d44b92] py-3 rounded-lg text-base font-medium transition-all duration-300 shadow-sm hover:shadow touch-target min-h-11"
      >
        {isSubmitting ? "Sending..." : "Send Message"}
      </Button>
    </form>
  )
}

export default ContactForm
